import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  providerBills: [],
  patientsResponsibilityBills: [],
  explanationOfBenefitsBills: [],
  collectionNoticeBills: [],
  subsequentProviderBills: [],
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PROVIDER_BILLS: {
      return updateObject(state, {
        providerBills: [...action.providerBills],
      });
    }
    case actionTypes.PATIENTS_RESPONSIBILITY_BILLS:
      return updateObject(state, {
        patientsResponsibilityBills: [...action.patientsResponsibilityBills],
      });

    case actionTypes.EXPLANATION_OF_BENEFITS_BILLS:
      return updateObject(state, {
        explanationOfBenefitsBills: [...action.explanationOfBenefitsBills],
      });

    case actionTypes.COLLECTION_NOTICE_BILLS:
      return updateObject(state, {
        collectionNoticeBills: [...action.collectionNoticeBills],
      });

    case actionTypes.SUBSEQUENT_PROVIDER_BILLS:
      return updateObject(state, {
        subsequentProviderBills: [...action.subsequentProviderBills],
      });
      
    default:
      return state;
  }
};
export default reducer;
